import { createSlice } from "@reduxjs/toolkit";
import {
  fetchNurseProfileReducer,
  updateNurseProfileReducer,
} from "../../reducer/profile/nurseProfileReducer";

import i18n from "../../i18n";
const initialState = {
  data: null,
  isLoading: false,
  isSaving: false,
  error: null,
};

const nurseProfileSlice = createSlice({
  name: "nurseProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNurseProfileReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNurseProfileReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload || null;
      })
      .addCase(fetchNurseProfileReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadProfile");
      })
      .addCase(updateNurseProfileReducer.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateNurseProfileReducer.fulfilled, (state, action) => {
        state.isSaving = false;
        state.data = action.payload || state.data;
      })
      .addCase(updateNurseProfileReducer.rejected, (state) => {
        state.isSaving = false;
      });
  },
});

export default nurseProfileSlice.reducer;
